import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { formatDoseDisplay } from '../../../utils/validators';

/**
 * DoseInput Component
 * Input field for dose entry with French locale formatting (comma as decimal separator)
 *
 * @param {Object} props
 * @param {string} props.value - Dose value (stored with dot as decimal separator)
 * @param {Function} props.onChange - Change handler (receives raw input value)
 * @param {string} props.placeholder - Placeholder text
 * @param {boolean} [props.disabled=false] - Whether input is disabled
 * @param {string} [props.size='large'] - Ant Design size
 * @param {string} [props.className] - Additional CSS classes
 */
const DoseInput = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  size = 'large',
  className = '',
}) => {
  return (
    <Input
      type="text"
      value={formatDoseDisplay(value)}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
      disabled={disabled}
      inputMode="decimal"
      pattern="[0-9,.\-]*"
      className={`h-11 ${className}`}
      size={size}
    />
  );
};

DoseInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
};

export default React.memo(DoseInput);
